module.exports = __webpack_public_path__ + "static/img/mo_icn_link_over@3x.31a0856.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/mo_icn_link_over@3x.png
// module id = pCzt
// module chunks = 10